import React from 'react';
import { Divider, Text } from 'wix-ui-tpa/cssVars';
import { classes } from './DividerSection.st.css';
import { FormType } from '../../../types/types';
import { useDividerSettings } from './useDividerSettings';
import { TEXT_DIRECTION } from '../../../constants';
import { useEnvironment } from '@wix/yoshi-flow-editor';

interface DividerSectionProps {
  formType: FormType;
}

export const DividerSection = ({ formType }: DividerSectionProps) => {
  const { dividerText } = useDividerSettings({ formType });
  const { isRTL } = useEnvironment();

  return (
    <div
      data-hook={`${formType}-divider`}
      className={classes.dividerSection}
      dir={isRTL ? TEXT_DIRECTION.RTL : TEXT_DIRECTION.LTR}
    >
      <Divider className={classes.dividerLine} />
      <Text
        data-hook={`${formType}-divider-text`}
        className={classes.dividerText}
      >
        {dividerText}
      </Text>
      <Divider
        className={`${classes.dividerLine} ${classes.dividerSecondLine}`}
      />
    </div>
  );
};
